import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Truck } from "@phosphor-icons/react";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="h-screen flex flex-col items-center justify-center bg-slate-50 gap-4">
        <div className="p-3 rounded-md bg-blue-600 text-slate-950 animate-pulse">
          <Truck size={32} weight="fill" />
        </div>
        <p className="text-slate-500 text-sm">Loading command center…</p>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}
